import { isRememberablePath, REDIRECT_AFTER_LOGIN_KEY } from '@app/features/oidc/redirectAfterLogin';
import UseRoutingContext from '@context/routing/useRoutingContext';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useTrackLocation = () => {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);
  const { getAllPaths } = UseRoutingContext();

  useEffect(() => {
    const currentPath = location.pathname;
    if (!isRememberablePath(currentPath)) return;

    // Only save valid routes - check if the route exists in the routing structure
    const allPaths = getAllPaths();
    const isValidRoute = allPaths.some((validPath) => currentPath.includes(validPath));

    if (isValidRoute) {
      sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, currentPath + location.search);
      previousPath.current = currentPath + location.search;
    }
  }, [location, getAllPaths]);

  return location;
};

export default useTrackLocation;
